import React from 'react';
import { Box, Container } from '@mui/material';

const Wrapper = ({ children, width }) => {
  return (
    <Box minHeight={'100svh'}>
      <Container maxWidth={width}>
        <Box display="flex" flexDirection={'column'} justifyContent="center" alignItems="center" minHeight={'94svh'}>
          {children}
        </Box>
      </Container>
    </Box>
  );
};

export default Wrapper;
